module.exports = __webpack_public_path__ + "static/media/delete.3b234781.svg";